import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[emDragCursor]'
})
export class DragCursorDirective {

  @HostListener('cdkDragStarted')
  onDragStart() {
    document.body.style.cursor = 'grabbing';
  }

  @HostListener('cdkDragEnded')
  onDragEnd() {
    document.body.style.cursor = '';
  }

}
